import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { BlogImageGallery as Original } from 'components/organisms'
import {
  BlogImageGallerySettings,
  BlogImageGalleryFloatingSettings,
} from './BlogImageGallerySettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { blogImageGalleryCardItemParams } from '../BlogImageGalleryCard'

export const defaultProps = {}

export const blogImageGalleryItemParams = (enabled, id, blockProps, children) => ({
  pk: id,
  children: getItemChildren(enabled, children?.[0], blogImageGalleryCardItemParams),
})

export const dynamicProps = []

export const BlogImageGallery: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-blog-image-gallery ${props.className}`}
      >
        <Original
          item={blogImageGalleryItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

BlogImageGallery.craft = withCraft({
  name: 'BlogImageGallery',
  defaultProps: defaultProps,
  settings: BlogImageGallerySettings,
  floatingSettings: BlogImageGalleryFloatingSettings,
})
